<template>
  <div class="login-wrapper">
    <login title="Sign up" no-forgot @login="onSignUp" @provider="onProvider">
      <div class="form-group">
        <input
          id="name"
          v-model="user.name"
          type="text"
          class="form-control"
          v-bind:class="[$v.name]"
          placeholder="Name"
          required
          autofocus
          aria-describedby="emailHelp"
          v-on:blur="onBlur($event)"
        />
        <div class="invalid-feedback">Your name is required</div>
      </div>
      <template v-slot:footer>
        <div class="login-footer">
          <span>Back to login </span><router-link to="login">Login</router-link>
        </div>
      </template>

    </login>
  </div>
</template>
<script>
import Login from "../../components/Auth/Login";
import { useValidator } from "src/components/validator.js"

export default {
  components: {
    Login
  },
  setup(props, context) {
    const store = context.root.$store
    const user = {
      name: ''
    }

    const $v = useValidator({
      name: {
        presence: { allowEmpty: false },
      }
    })
    function onBlur(e) {
      $v.validateEvent(e)
    }

    function onSignUp(e) {
      let isValid = $v.validateAll({
        name: user.name
      })
      isValid &= e.isValid
      if (isValid) {
        store.dispatch('authRegister', { name: user.name, email: e.credentials.email, password: e.credentials.password})
      }
    }

    function onProvider(provider) {
      store.dispatch('authProvider', { provider: provider })
    }
    return {
      user,
      onSignUp,
      onProvider,
      '$v': $v.model,
      onBlur
    }
  }
}
</script>
<style lang="scss">
</style>